import { configureStore } from "@reduxjs/toolkit";
import reducers from "./Reducer";
import config from "../config/envConfig";

const store = configureStore({
  reducer: reducers,
  devTools: config.reduxDevToolOption,
});
export default store;
